import React from 'react';

const Profile: React.FC = () => {
  return <div>User Profile</div>;
};

export default Profile;